import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';

// Apply the saved theme (light | dark | hybrid | hybrid-dark) BEFORE React
// mounts, so there's no flash of the wrong palette on first paint.
// ThemeProvider takes over after. The root carries `.dark` for dark +
// hybrid-dark; `data-theme` carries the exact choice for the Hybrid Dark
// canvas override in index.css.
if (typeof document !== 'undefined') {
  try {
    const THEMES = ['light', 'dark', 'hybrid', 'hybrid-dark'];
    const raw = localStorage.getItem('kocore-theme');
    const stored = THEMES.includes(raw) ? raw : 'dark'; // legacy 'system' → dark
    const dark = stored === 'dark' || stored === 'hybrid-dark';
    document.documentElement.classList.toggle('dark', dark);
    document.documentElement.setAttribute('data-theme', stored);
    document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  } catch {
    // If anything goes wrong, fall back to the signature dark look.
    document.documentElement.classList.add('dark');
    document.documentElement.setAttribute('data-theme', 'dark');
    document.documentElement.style.colorScheme = 'dark';
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
